import AppHeader from "../../layout/AppHeader";
import ExportMain from '../../xpost/views/services/export/ExportMain';
import ImportDeliveryUpload from '../../xpost/views/services/import/ImportDeliveryUpload';
import ImportMainUpload from '../../xpost/views/services/import/ImportMainUpload';

const ImportRoutes = [
  {
    path: "/servicos/importar",
    name: "services.import",
    components: {
      header: AppHeader,
      default: ImportMainUpload,
    }
  },
  {
    path: "/servicos/exportar",
    name: "services.export",
    components: {
      header: AppHeader,
      default: ExportMain,
    }
  },
  {
    path: "/servicos/importar/upload",
    name: "services.import.upload",
    components: {
      header: AppHeader,
      default: ImportMainUpload,
    }
  },
  {
    path: "/servicos/importar/destinatario",
    name: "services.import.delivery",
    components: {
      header: AppHeader,
      default: ImportDeliveryUpload,
    }
  },
  
]

export default ImportRoutes;
